import { CONFIGURATION_GET_GOOGLE_MAPS_KEY } from "../actions/configuration";
import { didInvalidate } from "../utils/errorHandler";

const INITIAL_STATE = {
  googleMapsKeys: {},
};

const artIdOf = (action) => String(action.meta?.idArt ?? action.payload?.idArt ?? "");

const configuration = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${CONFIGURATION_GET_GOOGLE_MAPS_KEY}_PENDING`: {
      const artId = artIdOf(action);
      if (!artId) return state;
      return {
        ...state,
        googleMapsKeys: {
          ...state.googleMapsKeys,
          [artId]: {
            isFetching: true,
            didInvalidate: false,
            data: typeof state.googleMapsKeys[artId]?.data === "string"
              ? state.googleMapsKeys[artId].data
              : null,
          },
        },
      };
    }
    case `${CONFIGURATION_GET_GOOGLE_MAPS_KEY}_FULFILLED`: {
      const artId = artIdOf(action);
      if (!artId) return state;
      const serverKey = typeof action.payload.data === "string" ? action.payload.data : "";
      return {
        ...state,
        googleMapsKeys: {
          ...state.googleMapsKeys,
          [artId]: {
            isFetching: false,
            didInvalidate: didInvalidate(action),
            data: serverKey,
          },
        },
      };
    }
    case `${CONFIGURATION_GET_GOOGLE_MAPS_KEY}_REJECTED`: {
      const artId = artIdOf(action);
      if (!artId) return state;
      return {
        ...state,
        googleMapsKeys: {
          ...state.googleMapsKeys,
          [artId]: {
            isFetching: false,
            didInvalidate: true,
            data: null,
          },
        },
      };
    }
    default:
      return state;
  }
};

export default configuration;
